(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.edit', [
      'ui.router'
    ]);
}());
